export const RommType = [
  {label: 'Standard', value: 'Standard'},
  {label: 'Deluxe', value: 'Deluxe'},
  {label: 'Suite', value: 'Suite'},
  {label: 'Excecutive', value: 'Excecutive'},
  {label: 'Otra', value: ''},
]

export const BoardType = [
    {label: 'Con desayuno', description: 'BB', value: 'Con desayuno'},
    {label: 'Sin desayuno', description: 'NB', value: 'Sin desayuno'},
    {label: 'Media pensión', description: 'HB', value: 'Media pensión'},
    {label: 'Pensión competa', description: 'FB', value: 'Pensión competa'},
    {label: 'Todo incluido', description: 'AI', value: 'Todo incluido'},
]

export const CategoryType = [
    {label: '⭐', description: '(1 estrella)', value: "1"},
    {label: '⭐⭐', description: '(2 estrellas)',value:"2"},
    {label: '⭐⭐⭐', description: '(3 estrellas)',value:"3"},
    {label: '⭐⭐⭐⭐', description: '(4 estrellas)',value:"4"},
    {label: '⭐⭐⭐⭐⭐', description: '(5 estrellas)',value:"5"},
]

export const BedType = [
    {label: 'King', value: 'King'},
    {label: 'Queen', value: 'Queen'},
    {label: 'Sofa bed', value: 'Sofa bed'},
    {label: 'Twin', value: 'twin'},
]

// rent-a-car

export const TimeDay = [
  {label: 'Diurno', value: 'Diurno'},
  {label: 'Nocturno', value: 'Nocturno'}
]

export const TransmissionType = [
    {label: 'Manual', value: 'Manual'},
    {label: 'Automático', value: 'Automático'}
]

export const VehicleTypesCar = [
  {label: 'Sedan', value: 'Sedan'},
  {label: 'Familiar', value: 'Familiar'},
  {label: 'Ejecutivo', value: 'Ejecutivo'},
  {label: 'Minivan', value: 'Minivan'},
  {label: 'Van', value: 'Van'},
  {label: 'Sports', value: 'Sports'},
  {label: 'Minibus', value: 'Minibus'}
]

// transfer

export const TypeTransfer = [
  {label: 'Privado', value: 'Privado'},
  {label: 'Regular', value: 'Regular'}
]

export const VehicleTypes = [
  {label: 'Sedán', value: 'Sedán'},
  {label: 'SUV', value: 'SUV'},
  {label: 'Minivan', value: 'Minivan'},
  {label: 'Camioneta', value: 'Camioneta'},
  {label: 'Minibús', value: 'Minibus'},
  {label: 'Autobús', value: 'Autobús'},
  {label: 'Vehículo de lujo', value: 'Vehículo de lujo'},
  {label: 'Limusina', value: 'Limusina'},
  {label: 'Pickup', value: 'Pickup'},
  {label: 'Blindado', value: 'Blindado'}
]

export type ExperienceType = 'city' | 'shows' | 'guiada' | 'barco' | 'excursion' | 'aventura';

export const EXPERIENCE_TYPES: { key: ExperienceType; label: string; icon: string }[] = [
  { key: 'city', label: 'City tour', icon: 'building' },
  { key: 'shows', label: 'Shows / eventos', icon: 'sparkles' },
  { key: 'guiada', label: 'Visita guiada', icon: 'compass' },
  { key: 'barco', label: 'Paseo en barco', icon: 'ship' },
  { key: 'excursion', label: 'Excursiones', icon: 'map' },
  { key: 'aventura', label: 'Acción y aventura', icon: 'zap' }
];

export interface ExperienceDetail {
  modality: string[];
  durationQty: string;
  durationUnit: 'horas' | 'dias';
  halfFull: string[];
  food: string[];
  location: string;
  category: string[];
  excursionType: string;
}

export const EMPTY_EXPERIENCE_DETAIL: ExperienceDetail = {
  modality: [],
  durationQty: '',
  durationUnit: 'horas',
  halfFull: [],
  food: [],
  location: '',
  category: [],
  excursionType: ''
};
